export default __webpack_public_path__ + "static/media/icon_manufacturing_Diestruck.6c71b6cc.png";